var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCircleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99985 19.6136C4.68942 19.6136 0.384464 15.3086 0.384464 9.9982C0.384464 4.68777 4.68942 0.382812 9.99985 0.382812C15.3103 0.382812 19.6152 4.68777 19.6152 9.9982C19.6152 15.3086 15.3103 19.6136 9.99985 19.6136Z",
    stroke: "#404040",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46657 9.84661L8.32118 7.00507C8.42502 6.90877 8.5622 6.85658 8.70379 6.85949C8.84538 6.8624 8.98031 6.92019 9.0801 7.02068C9.17989 7.12117 9.23674 7.2565 9.23867 7.3981C9.24059 7.53971 9.18744 7.67653 9.09041 7.77969L7.17349 9.68738H13.9427C14.0877 9.68738 14.2267 9.74497 14.3292 9.84747C14.4317 9.94996 14.4893 10.089 14.4893 10.2339C14.4893 10.3789 14.4317 10.5179 14.3292 10.6204C14.2267 10.7229 14.0877 10.7805 13.9427 10.7805H7.17349L9.09041 12.6881C9.18744 12.7913 9.24059 12.9281 9.23867 13.0697C9.23674 13.2113 9.17989 13.3467 9.0801 13.4472C8.98031 13.5476 8.84538 13.6054 8.70379 13.6084C8.5622 13.6113 8.42502 13.5591 8.32118 13.4628L5.46657 10.6212C5.41561 10.5704 5.37518 10.5101 5.34759 10.4436C5.32 10.3771 5.3058 10.3059 5.3058 10.2339C5.3058 10.162 5.32 10.0907 5.34759 10.0242C5.37518 9.95778 5.41561 9.89742 5.46657 9.84661Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/arrow-circle-left.88c89cbcd74b30f081d045af4d6a006c.svg";
export { ForwardRef as ReactComponent };